// extracted by mini-css-extract-plugin
module.exports = {"root":"classes_root__3eolW","table":"classes_table__2MNyM"};